import React from 'react';
import ProductCardHome from '../../NewStoreHomeWeb/BestsellerNew/ProductCardHome';
import { NewProductSection } from './styled';

function ProductSection(props) {
  const { productData, setChangeCartCount, selectDiaperRef, stretchMarksPage } =
    props;
  return (
    <NewProductSection stretchMarksPage={stretchMarksPage} sectionBgColor={productData?.sectionBgColorStart}>
      {productData?.sectionBgImage ? (
        <img
          className="headerImage"
          src={productData?.sectionBgImage}
          alt=""
          ref={selectDiaperRef}
        />
      ) : null}
      <div className="productContainer">
        {productData?.items?.map((element, index) => {
          return (
            <ProductCardHome
              itemId={`element-${index}`}
              productInfo={element}
              setChangeCartCount={setChangeCartCount}
              key={`element-${element?._id}${index}`}
              store={true}
            />
          );
        })}
      </div>
    </NewProductSection>
  );
}

export default ProductSection;
